import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';

const Footer = () => {
    const { t } = useLanguage();

    return (
        <Box component="footer" sx={{ mt: 'auto' }}>
            {/* Roter Balken mit statischem Auto */}
            <Box
                sx={{
                    backgroundColor: '#e1090c',
                    height: '50px',
                    position: 'relative',
                    overflow: 'hidden',
                    borderBottom: '2px solid #333',
                    display: 'flex', // Zentriert das Auto horizontal
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                <Box
                    component="img"
                    src="//carrera-toys.com/cdn/shop/files/Car_1_600x.png?v=1751638473"
                    alt="Racing Car"
                    sx={{
                        height: '80%',
                        // GEÄNDERT: Animation entfernt, Auto ist jetzt statisch in der Mitte
                    }}
                />
            </Box>

            {/* Haupt-Footer (schwarz) */}
            <Box
                sx={{
                    backgroundColor: '#000',
                    color: 'white',
                    py: 4,
                    px: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 3,
                }}
            >
                <Box
                    component="img"
                    src="//carrera-toys.com/cdn/shop/files/Link_-_Zuruck_zur_Startseite_Picture_carrera_logo_png_431x.png?v=1751639075"
                    alt="Carrera Logo"
                    sx={{
                        height: '40px',
                        maxWidth: '150px'
                    }}
                />

                <Box sx={{ display: 'flex', gap: 3 }}>
                    {/* GEÄNDERT: Externer Link für das Impressum */}
                    <Link
                        href="https://carrera-toys.com/de-at/pages/legal-notice"
                        target="_blank" // Öffnet in neuem Tab
                        rel="noopener noreferrer" // Wichtig für Sicherheit
                        color="inherit"
                        underline="hover"
                        sx={{ fontSize: '0.8rem' }}
                    >
                        {t('footer_imprint')}
                    </Link>
                    <Link
                        href="/beta-tester-agreement"
                        color="inherit"
                        underline="hover"
                        sx={{ fontSize: '0.8rem' }}
                    >
                        Nutzungsbedingungen
                    </Link>
                    <Link
                        component={RouterLink}
                        to="/datenschutz"
                        color="inherit"
                        underline="hover"
                        sx={{ fontSize: '0.8rem' }}
                    >
                        {t('footer_privacy')}
                    </Link>
                </Box>

                <Typography variant="caption" sx={{ color: '#888' }}>
                    &copy; {new Date().getFullYear()} Carrera Toys GmbH
                </Typography>
            </Box>
        </Box>
    );
};

export default Footer;